import { render, staticRenderFns } from "./mohon.vue?vue&type=template&id=4a0dc817&"
import script from "./mohon.vue?vue&type=script&lang=js&"
export * from "./mohon.vue?vue&type=script&lang=js&"
import style0 from "./mohon.vue?vue&type=style&index=0&id=4a0dc817&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports